@if (isError && !isLoading) {
  <div class="h-[80%]">
    <app-something-went-wrong
      [showPicture]="false"
      (retryEmitter)="retryData()"></app-something-went-wrong>
  </div>
}

@if (!isError) {
  <div class="flex-col-container-1">
    <div class="search-panel">
      <div class="button-group">
        <button
          mat-raised-button
          color="primary"
          class="page-block-button"
          aria-label="Add template"
          (click)="openCreateModelForm()">
          <mat-icon class="{{ useMobileView ? '!m-0' : '' }}">add</mat-icon>
          {{ useMobileView ? '' : ('newTemplate' | translate) }}
        </button>
        @if (isExporting) {
          <div class="w-[2.5rem]">
            <app-loader
              padding="0"
              [diameter]="'22'"
              height="100%"></app-loader>
          </div>
        } @else {
          <button
            mat-icon-button
            [attr.aria-label]="'exportExcel' | translate"
            (click)="exportExcel()"
            matTooltip="{{ 'exportExcel' | translate }}">
            <i class="far fa-file-excel fa-xs"></i>
          </button>
        }
      </div>
      <div class="search-bar">
        <app-search-bar
          [fullWidth]="useMobileView"
          (searchEventEmitter)="onSearch()"
          (valueChangedEventEmitter)="onSearchValueChanged($event)"
          [search]="searchValue"></app-search-bar>
        @if (!useMobileView) {
          <app-table-header
            [countTotal]="totalSize"
            (reloadEventEmitter)="reload()"
            [isReloadLoading]="isReloadLoading"></app-table-header>
        }
      </div>
    </div>
  </div>
}

@if (useMobileView) {
  <app-table-header
    [countTotal]="totalSize"
    (reloadEventEmitter)="reload()"
    (searchOrderChangeEventEmitter)="searchOrderChange($event)"
    (changeOrderEventEmitter)="changeOrder()"
    [searchOrder]="searchOrder"
    [searchOrders]="searchOrders"
    [orderDirection]="filter.orderDirection"
    [isReloadLoading]="isReloadLoading"></app-table-header>
  @if (!isLoading && !isError) {
    <div class="h-full">
      <app-infinity-scroll
        [isErrorScroll]="isErrorScroll"
        [isLoadingScroll]="isLoadingScroll"
        [canNavigateForward]="canNavigateForward"
        [dataLength]="dataSource.data.length"
        (loadData)="onScroll()"
        (refreshData)="refreshData()">
        <div class="mobile-container-cards">
          @for (template of dataSource.data; track template) {
            <div>
              <div class="card">
                <mat-card class="mobile-row">
                  <mat-card-content
                    (click)="openEditModelForm(template)"
                    class="flex flex-1">
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'templateName' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ template.name }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'templateDesc' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{ template?.description ?? '' }}
                      </div>
                    </div>
                    <div class="card-table-row">
                      <div class="card-table-row-header">
                        {{ 'modifyDate' | translate }}:
                      </div>
                      <div class="card-table-row-value">
                        {{
                          template?.modifyDate
                            ? (template.modifyDate
                              | date: 'dd/MM/yyyy HH:mm:ss')
                            : ''
                        }}
                      </div>
                    </div>
                  </mat-card-content>
                  <div class="icons-mobile-block">
                    <button
                      mat-icon-button
                      aria-label="Edit"
                      matTooltip="{{ 'edit' | translate }}"
                      (click)="openEditModelForm(template)">
                      <mat-icon>edit_outline</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      matTooltip="{{ 'delete' | translate }}"
                      color="primary"
                      aria-label="Delete"
                      (click)="
                        openConfirmDialog(template.templateId, template.name)
                      ">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                </mat-card>
              </div>
            </div>
          }
        </div>
        @if (!dataSource.data.length) {
          <app-no-data></app-no-data>
        }
      </app-infinity-scroll>
    </div>
  }
}

@if (!useMobileView && !isLoading && !isError) {
  <div class="settings-table-container h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="templateName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'templateName' | translate }}
          </th>
          <td mat-cell *matCellDef="let template">{{ template.name }}</td>
        </ng-container>
        <ng-container matColumnDef="templateDesc">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'templateDesc' | translate }}
          </th>
          <td mat-cell *matCellDef="let template">
            {{ template?.description ?? '' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="modifyDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'modifyDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let template">
            {{ template.modifyDate | date: 'dd/MM/yyyy HH:mm:ss' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
          <td mat-cell *matCellDef="let template">
            <button
              mat-icon-button
              [attr.aria-label]="'modifyTemplate' | translate"
              matTooltip="{{ 'modifyTemplate' | translate }}"
              (click)="openEditModelForm(template)">
              <mat-icon>edit_outline</mat-icon>
            </button>
            <button
              mat-icon-button
              aria-label="Delete"
              matTooltip="{{ 'delete' | translate }}"
              (click)="openConfirmDialog(template.templateId, template.name)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-default"></tr>
      </table>

      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (isLoading) {
  <div class="flex-1 overflow-hidden">
    <app-skeleton-table></app-skeleton-table>
  </div>
}

<ng-template #createDrawer>
  <app-mail-account-template-create-dialog
    (closeEventEmitter)="onCloseCreateModalForm()"
    (submitEventEmitter)="onCreateTemplate()"
    [mailAccountId]="mailAccountId"
    [templateId]="editingTemplateId"></app-mail-account-template-create-dialog>
</ng-template>
